import { css } from '@compiled/react';
import { ConfluenceBannerMessage } from '@post-office/components--confluence-banner-message';
import { useMessageContext } from '@post-office/message-context';
import { type ComponentProps, type FunctionComponent } from 'react';

import { CTAButton } from './components/cta';
import { Divider } from './components/divider';
import { ValueProposition } from './components/value-proposition';
import { type App } from './types';

export type Props = {
	app: App;
	/** The default background image of the panel, defaults to 'hills' */
	backgroundImage?: 'hills' | 'arrows' | 'swirls' | 'stars';
	/** Should be used for hiding the message when dismissed. The messageDismissed event should not need to be fired using this. It will be fired internally within the message */
	onDismissed?: (messageInstanceId: string) => void;
	whyAmISeeingThisModalContent?: ComponentProps<
		typeof ConfluenceBannerMessage
	>['whyAmISeeingThisModalContent'];
	extraAnalyticsAttributes?: Record<string, string>;
};

type PropsWithApp = {
	app: App;
};

const bodyContentContainerStyles = css({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	height: 'fit-content',
	maxWidth: '870px',
});

const BodyContent: FunctionComponent<PropsWithApp> = ({ app }) => {
	return (
		<div css={bodyContentContainerStyles}>
			{app.logo}
			<Divider />
			<ValueProposition app={app} />
			<CTAButton app={app} />
		</div>
	);
};

export const ConfluenceBannerFirstPartyRecommendation = ({
	app,
	onDismissed,
	backgroundImage,
	whyAmISeeingThisModalContent,
}: Props) => {
	const { messageInstanceId } = useMessageContext();
	if (!messageInstanceId) {
		throw new Error('messageInstanceId is required');
	}
	return (
		<ConfluenceBannerMessage
			backgroundImage={backgroundImage}
			onDismissed={onDismissed}
			whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
			bodyContent={<BodyContent app={app} />}
		/>
	);
};
